export const SERVICE_URL = 'http://localhost:9100';
export const WS_SERVICE_URL = 'ws://localhost:7666';
export const CLIENT_URL = 'http://localhost:7101';
export const MONITOR_URL_TEMPLATE = 'http://localhost:7100/monitor/{roomId}';
export const SUPERADMIN_ID = 1;
export const MANAGER_ID = 2;
export const userTypes = [
    {
        id: SUPERADMIN_ID,
        name: 'Superadmin'
    },
    {
        id: MANAGER_ID,
        name: 'Animador'
    }
];
